import {
    TEMPLATE_OPEN_MODAL,
    TEMPLATE_CREATE_REQUEST,
    TEMPLATE_CREATE_RESULT,
    TEMPLATE_UPDATE_REQUEST,
    TEMPLATE_UPDATE_RESULT,
    TEMPLATE_SEARCH_REQUEST,
    TEMPLATE_SEARCH_RESULT,
    TEMPLATE_GET_REQUEST,
    TEMPLATE_GET_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    imageList: [],
    create: null,
    update: null,
    templates: [],
    template: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        
        case TEMPLATE_OPEN_MODAL:
            return { ...state, openModal: action.payload }

        case TEMPLATE_CREATE_REQUEST:
            return { ...state, loading: true }

        case TEMPLATE_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case TEMPLATE_UPDATE_REQUEST:
            return { ...state, loading: true }

        case TEMPLATE_UPDATE_RESULT:
            return { ...state, loading: false, update: action.payload }

        case TEMPLATE_SEARCH_REQUEST:
            return { ...state, loading: true }

        case TEMPLATE_SEARCH_RESULT:
            return { ...state, loading: false, templates: action.payload }

        case TEMPLATE_GET_REQUEST:
            return { ...state, loading: true }

        case TEMPLATE_GET_RESULT:
            return { ...state, loading: false, template: action.payload }

        case CLEAR_REDUX:
            return ["", "TEMPLATES"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};